import React, { useState, useEffect, useCallback } from "react";
import PageHeader from "../components/common/PageHeader";
import { useParams } from "react-router-dom";
import GoToTop from "../helpers/GoToTop";
import { useForm } from "react-hook-form";
import ApiService from "../api/ApiService";
import MetaData from "../helpers/MetaData";

const AnnadaanSevaFeedbackForm = () => {
    const { _id } = useParams();
    const [top, setTop] = useState(0);
    const [submitted, setSubmitted] = useState(false);
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm();

    const challengeSelected = watch("challenges") === "Yes";

    useEffect(() => {
        const checkFeedbackStatus = async () => {
            try {
                const res = await ApiService.getAnnadaanSevaRegistration(_id);
                if (res?.feedback) {
                    setAlreadySubmitted(true);
                }
            } catch (error) {
                console.error("Error fetching registration:", error);
            }
        };
        checkFeedbackStatus();
    }, [_id]);

    const onSubmit = async (data) => {
        try {
            const payload = {
                id: _id,
                feedback: data.feedback,
                inspiration: data.inspiration,
                organization_clarity: data.organization_clarity,
                challenges: data.challenges,
                challenge_details: data.challenge_details,
                suggestions: data.suggestions, // 🆕 new field
            };


            await ApiService.submitAnnadaanSevaFeedback(payload);
            reset();
            setSubmitted(true);
        } catch (err) {
            if (err.response?.data?.message === "Your feedback has already been submitted.") {
                setAlreadySubmitted(true);
            }
            console.error("Submit error:", err);
        }
    };

    const festRef = useCallback((node) => {
        if (node) {
            setTop(node.offsetTop - 92);
        }
    }, []);

    return (
        <>
            <MetaData title="Annadaan Seva Feedback - ISKCON Attapur" />
            <PageHeader title="Annadaan Seva Feedback" imgSrc="/images/page-header/17.webp" />
            <section className="connect-heading-sec" ref={festRef}>
                <div className="container">
                    {alreadySubmitted ? (
                        <div className="heading text-center">
                            <h4>Your feedback has already been submitted. Thank you!</h4>
                        </div>
                    ) : submitted ? (
                        <div className="heading text-center">
                            <h4>Thank you for sharing your experience!</h4>
                        </div>
                    ) : (
                        <>
                            <h5 className="mb-4 text-center" style={{ fontWeight: 'normal', fontSize: '1rem', lineHeight: '1.6' }}>
                                Thank you for being part of the Annadaan Seva. Your feedback will help us improve and serve better. Kindly take a moment to share your experience below.
                            </h5>

                            <form onSubmit={handleSubmit(onSubmit)} className="p-3 border rounded" style={{ backgroundColor: "#f9f9f9" }}>

                                {/* Q1: Inspiration */}
                                <div className="mb-3">
                                    <label className="form-label" style={{ fontSize: '1.1rem' }}>What inspired you to join the Annadaan Seva?</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="Spiritual purpose" {...register("inspiration")} />
                                        <label className="form-check-label">Spiritual purpose</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="Community service" {...register("inspiration")} />
                                        <label className="form-check-label">Community service</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="Word of mouth" {...register("inspiration")} />
                                        <label className="form-check-label" >Word of mouth</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="Other" {...register("inspiration")} />
                                        <label className="form-check-label">Other</label>
                                    </div>
                                </div>

                                {/* Q2: Organization clarity */}
                                <div className="mb-3">
                                    <label className="form-label" style={{ fontSize: '1.1rem' }}>Was the seva well-organized and clear in instructions?</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" value="Yes" {...register("organization_clarity")} />
                                        <label className="form-check-label">Yes</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" value="Somewhat" {...register("organization_clarity")} />
                                        <label className="form-check-label">Somewhat</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" value="No" {...register("organization_clarity")} />
                                        <label className="form-check-label">No</label>
                                    </div>
                                </div>

                                {/* Q3: Challenges */}
                                <div className="mb-3">
                                    <label className="form-label" style={{ fontSize: '1.1rem' }}>Did you face any challenges during the seva?</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" value="No" {...register("challenges")} />
                                        <label className="form-check-label">No</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" value="Yes" {...register("challenges")} />
                                        <label className="form-check-label">Yes – Please specify:</label>
                                    </div>
                                    {challengeSelected && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="If yes, please describe"
                                            {...register("challenge_details")}
                                        />
                                    )}
                                </div>

                                {/* Main Experience Text */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" style={{ fontSize: '1.1rem' }}>
                                        What did you enjoy most about the experience?
                                    </label>
                                    <input
                                        {...register("feedback", { required: "Please share your experience." })}
                                        className="form-control"
                                        rows={5}
                                        placeholder="How was your experience serving prasadam?"
                                        style={{ fontSize: "0.95rem" }}
                                    />
                                    {errors.feedback && (
                                        <small className="text-danger">{errors.feedback.message}</small>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" style={{ fontSize: '1.1rem' }}>
                                        Any suggestions to improve future Annadaan Seva programs?
                                    </label>
                                    <input
                                        {...register("suggestions")}
                                        className="form-control"
                                        rows={4}
                                        placeholder="We'd love to hear your ideas or improvements."
                                        style={{ fontSize: "0.95rem" }}
                                    />
                                </div>


                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    className="btn btn-block"
                                    style={{
                                        backgroundColor: "#F3B01B",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 20px",
                                        fontWeight: "bold"
                                    }}
                                >
                                    Submit Feedback
                                </button>
                            </form>


                        </>
                    )}
                </div>
            </section>
            <GoToTop top={top} />
        </>
    );
};

export default AnnadaanSevaFeedbackForm;
